import {Injectable, DestroyRef, inject} from "@angular/core"
import {Subject} from "rxjs"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Injectable({
    providedIn: "root",
})
export class ScanningService {
    private readonly destroyRef = inject(DestroyRef)
    log = new Subject<string>()
    logs = ""

    constructor() {
        this.log.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((newLog) => this.appendLog(newLog))
    }

    private appendLog(newLog: string): void {
        if (this.logs.length > 0) newLog = `\n${newLog}`
        this.logs += `${newLog}`
    }

    clearLogs(): void {
        this.logs = ""
    }
}
